import React from "react";
import {
  ThemeProvider as MuiThemeProvider,
  createTheme,
} from "@mui/material/styles";

export const ThemeProviderWrapper = ({ children }) => {
  // Always use light mode
  const theme = createTheme({
    palette: {
      mode: "light",
      primary: {
        main: "#6e41e2",
      },
      background: {
        default: "#f4f7fa",
        paper: "#ffffff",
      },
    },
  });

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};
